import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import {getCurrentCustodianVersion, getRegionDetails, setCurrentCustodianVersion} from "../components/Requests/Requests";

import {
  StandardScreen,
  StandardSearchBox, 
  StandardDropdown, 
  StandardButton, 
  StatusMessage, 
  PageLayout,
  StandardText
} from '../components/Layout';
import theme from '../styles/theme.js';

class SwitchCustodian extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading: false,
            error:"", 
            currentCustodianVersion: "",
            currentRegionName: "",
            regionUrlToSet: "",
            spHostUrl: "",
            regions: [],
            regionNameChosen: "",
            regionSet: false,
            hasSearched: false,
            hasSwitchableRegions: false 
        }
    }
  
    getCurrentCustodianVersion(spHostUrl) {
            this.setState({loading:true})
            getCurrentCustodianVersion(this.props.accessToken, spHostUrl).then((response) => {
        if (response.status === 200) {
            response.json().then((data) => {
                if (data.custodianUrl) {
                    // Configuration found
                    this.setState({ 
                        loading: false, 
                        currentCustodianVersion: data.custodianUrl,
                        hasSearched: true
                    })
                    this.getRegions(data.custodianUrl);
                } else {
                    // No configuration found (custodianUrl is null)
                    this.setState({
                        loading: false,
                        currentCustodianVersion: "",
                        hasSearched: true
                    });
                }
            });
        } else {
            this.setState({loading:false, error:"Something went wrong"});
        }
    });
            }

    setCustodianVersion(spHostUrl, version) {
        this.setState({loading:true})
        setCurrentCustodianVersion(this.props.accessToken, spHostUrl, version).then((response) => {
                if (response.status === 200) {
                    response.json().then((data) => {
                        this.setState({ loading: false, currentCustodianVersion: data.custodianUrl})
                        this.setState({regionSet: true})
                        this.refreshComponents();
                    });
                } else {
                    this.setState({ loading: false, error: "Something went wrong" });
                }
            });
    }

    getRegions(currentRegionUrl) {
        this.setState({ loading: true })
        getRegionDetails(this.props.accessToken).then((response) => {
            if (response.status === 200) {
                response.json().then((data) => {
                    if (data) {
                        const currentRegion = data.find((item) => item.regionUrl === currentRegionUrl);
                        this.setState({ currentRegionName: currentRegion ? currentRegion.regionName : currentRegionUrl})

                        // Filter for switchable regions only for the dropdown
                        const switchableRegions = data.filter((item) => item.regionUrl !== currentRegionUrl && item.regionAllowSwitch);
                        
                        this.setState({ 
                            loading: false, 
                            regions: switchableRegions.map((item) => {return {key: item.regionUrl, text: item.regionName}}),
                            hasSwitchableRegions: switchableRegions.length > 0
                        })
                    } else {
                        this.setState({loading: false, regions: null})
                    }});
            } else {
                this.setState({ loading: false, error: "Something went wrong" });
            }
        });
    }

    getVersionAndRegions(spHostUrl) {
        this.setState({ regionSet: false});
        this.setState({ regionUrlToSet: null});
        this.getCurrentCustodianVersion(spHostUrl);
    }

    onSelectVersion = (event, item) => {
        this.setState({ regionUrlToSet: item.key}); 
        this.setState({ regionNameChosen: item.text})   
    };

    onSpHostUrlChange = (newValue) => {
        this.setState({ 
            spHostUrl: newValue,
            // Clear previous search results when user starts typing
            currentCustodianVersion: "",
            currentRegionName: "",
            regions: [],
            regionUrlToSet: "",
            regionNameChosen: "",
            regionSet: false,
            hasSearched: false,  // Reset search flag
            error: ""
        });
    };

    refreshComponents() {
        this.setState({ regions: [] });
        this.setState({ spHostUrl: "" });
    }

    render() {
        const { 
            loading, 
            error, 
            spHostUrl, 
            currentCustodianVersion, 
            currentRegionName,
            regionUrlToSet,
            regions,
            regionNameChosen,
            regionSet,
            hasSearched
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Search SPHostUrl to find the configured environment"
                    description="Enter the SP host url of the site you wish to switch environments for."
                    loading={loading}
                >

                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={spHostUrl}
                        onChange={this.onSpHostUrlChange}
                    />

                    <StandardButton
                        text='Search'
                        disabled={spHostUrl.length === 0}
                        onClick={() => this.getVersionAndRegions(spHostUrl)}
                    />

                    {regionSet && (
                        <StatusMessage type="success">
                            Environment switched to <strong>{regionNameChosen}</strong> successfully
                        </StatusMessage>
                    )}

                    {hasSearched && !currentCustodianVersion && !loading && (
                        <StatusMessage type="warning">
                            No configured environment detected
                        </StatusMessage>
                    )}

                    {currentCustodianVersion && currentRegionName && (
                        <>
                            <StandardText
                                color={theme.colors.primary}
                                variant='body'
                            >
                                Current environment detected: <span style={{ color: theme.colors.text }}>{currentRegionName} </span>
                            </StandardText>
                            
                            <br></br>

                            {regions.length !== 0 ? (
                                <>
                                    <StandardDropdown
                                        label="Environment to switch to"
                                        selectedKey={regionUrlToSet}
                                        onChange={this.onSelectVersion}
                                        placeholder="Select Environment"
                                        options={regions}
                                        disabled={spHostUrl.length === 0}
                                    />

                                    <StandardButton
                                        text='Switch'
                                        onClick={() => this.setCustodianVersion(spHostUrl, regionUrlToSet)}
                                        disabled={!regionUrlToSet || spHostUrl.length === 0}
                                    />
                                </>
                            ) : (
                                <StandardText
                                    variant='body'
                                    color={theme.colors.warning}
                                >
                                   <b> No switchable environments available </b>
                                </StandardText>
                            )}
                        </>
                    )}

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}
export default SwitchCustodian;